import React, { useEffect, useState } from "react";
import { endPoint } from "../global";
import ParticleBackground from "../components/ParticleBackground";
import {
  Box,
  Button,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Loading from "../components/Loading";
import ResponseAlert from "../components/ResponseAlert";

const Login = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const { login, token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [phoneNo, setPhoneNo] = useState("");
  const [response, setResponse] = useState("");
  const [success, setSuccess] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(endPoint + "login", { phoneNo });
      login(res.data.accessToken);
      navigate("/profile");
    } catch (error) {
      setOpenAlert(true);
      setResponse(error.response?.data?.msg ?? "Terjadi kesalahan. Coba lagi.");
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) return;
    try {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) {
        localStorage.removeItem("accessToken");
        navigate("/");
      } else {
        navigate("/profile");
      }
    } catch {
      localStorage.removeItem("accessToken");
      navigate("/");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      component="form"
      onSubmit={handleFormSubmit}
      sx={{
        minHeight: "100vh",
        backgroundImage: isMobile
          ? `url("/Background Login Mobile.jpg")`
          : `url("/Background Desktop.jpg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        pt: { xs: 8, md: 6 },
        position: "relative",
        overflow: "hidden",
        px: 3,
      }}
    >
      <ParticleBackground />

      {/* Brand logos */}
      <img
        src="SolarTuffNatGath.png"
        alt="SolarTuffNatGath"
        style={{ width: 320, objectFit: "contain", zIndex: 1, marginBottom: 8 }}
      />
      <img
        src="Theme Title.png"
        alt="Strength of Loyalty & Relationships"
        style={{
          width: 320,
          objectFit: "contain",
          zIndex: 1,
          marginBottom: 36,
        }}
      />

      {/* Frosted glass card */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 420,
          zIndex: 1,
          background: "rgba(255,255,255,0.22)",
          backdropFilter: "blur(18px)",
          borderRadius: "20px",
          border: "1px solid rgba(255,255,255,0.4)",
          p: 3,
        }}
      >
        <Typography
          sx={{
            fontFamily: "'Poppins', sans-serif",
            textAlign: "center",
            color: "#0f1f45",
            fontWeight: 500,
            fontSize: "0.9rem",
            lineHeight: 1.7,
            mb: 2.5,
          }}
        >
          Silahkan masukkan nomor Handphone
          <br />
          WA Anda yang terdaftar.
        </Typography>

        <TextField
          required
          fullWidth
          type="text"
          placeholder="Masukkan No. HP"
          value={phoneNo}
          onChange={(e) => setPhoneNo(e.target.value)}
          autoComplete="off"
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              backgroundColor: "rgba(255,255,255,0.75)",
              borderRadius: "12px",
              color: "#111",
              "& fieldset": { borderColor: "rgba(0,0,0,0.12)" },
              "&:hover fieldset": { borderColor: "rgba(0,0,0,0.25)" },
              "&.Mui-focused fieldset": { borderColor: "#1e3a6e" },
            },
            "& input": {
              color: "#111",
              textAlign: "center",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "1rem",
            },
            "& input::placeholder": {
              color: "rgba(0,0,0,0.4)",
              textAlign: "center",
            },
          }}
        />

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            background: "#1e3a6e",
            borderRadius: "12px",
            py: 1.6,
            fontSize: "1rem",
            fontWeight: 700,
            fontFamily: "'Poppins', sans-serif",
            textTransform: "none",
            boxShadow: "0 6px 24px rgba(15,31,69,0.5)",
            "&:hover": { background: "#162d57" },
          }}
        >
          Masuk
        </Button>
      </Box>

      <Loading open={loading} />
      <ResponseAlert
        response={response}
        success={success}
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
      />
    </Box>
  );
};

export default Login;
